import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.5 1.00098C14.5094 1.00098 15.3328 1.82466 15.333 2.83398V8.5H14.333V3.79395L8.45312 7.91016C8.28104 8.03054 8.05198 8.03052 7.87988 7.91016L2 3.79395V10.834C2.00027 11.2908 2.37613 11.6678 2.83301 11.668H6V12.668H2.83301C1.82384 12.6678 1.00027 11.8431 1 10.834V2.83398C1.00018 1.82477 1.82379 1.00115 2.83301 1.00098H13.5ZM2.83301 2.00098C2.45781 2.00112 2.13696 2.25401 2.03418 2.59766L8.16602 6.88965L14.2979 2.59863C14.1953 2.25457 13.8756 2.00098 13.5 2.00098H2.83301Z"
      fill="#2F2C88"
    />
    <path d="M7.5 10V13H10.5" stroke="#2F2C88" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18.5 18V15H15.5" stroke="#2F2C88" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M17.245 12.4998C16.9914 11.7832 16.5604 11.1425 15.9923 10.6375C15.4241 10.1325 14.7373 9.77968 13.9959 9.61192C13.2544 9.44417 12.4826 9.46696 11.7524 9.67818C11.0222 9.8894 10.3574 10.2822 9.82 10.8198L7.5 12.9998M18.5 14.9998L16.18 17.1798C15.6426 17.7174 14.9778 18.1102 14.2476 18.3214C13.5174 18.5326 12.7456 18.5554 12.0041 18.3877C11.2627 18.2199 10.5759 17.8671 10.0077 17.3621C9.43957 16.8571 9.00858 16.2164 8.755 15.4998"
      stroke="#2F2C88"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ResendIcon = (props) => <Icon component={svg} {...props} />;

export default ResendIcon;
